import React from "react";
import { useDispatch } from "react-redux";

import MaterialTable from "material-table";

import {
  updateCompanySubsidiary,
  getCompanySubsidiaries,
} from "../../helpers/services/CompanyServices";
import CompanyActionTypes from "../../redux/company/company.types";

export default ({ companyId, subsidiaries }) => {
  const dispatch = useDispatch();

  var subsidiariesColumns = [
    { title: "id", field: "id", hidden: true },
    {
      title: "Firma",
      field: "name",
    },
    {
      title: "Kundennummer",
      field: "customer_no",
    },
    {
      title: "Umsatzsteuernummer",
      field: "vat_id",
    },
    {
      title: "Handelsregisternummer",
      field: "register_no",
    },
    {
      title: "Straße",
      field: "street",
      validate: (rowData) => (rowData.street === "" ? "erforderlich" : ""),
    },
    {
      title: "Hausnummer",
      field: "house_no",
      validate: (rowData) => (rowData.house_no === "" ? "erforderlich" : ""),
    },
    {
      title: "PLZ",
      field: "zip_code",
      validate: (rowData) => (rowData.zip_code === "" ? "erforderlich" : ""),
    },
    {
      title: "Ort",
      field: "city",
      validate: (rowData) => (rowData.city === "" ? "erforderlich" : ""),
    },
    {
      title: "Land",
      field: "country",
      lookup: { Deutschland: "Deutschland" },
      validate: (rowData) => (rowData.street === "" ? "erforderlich" : ""),
    },
  ];

  const refreshData = async () => {
    console.log(companyId);
    const response = await getCompanySubsidiaries(companyId);
    dispatch({
      type: CompanyActionTypes.RETRIEVE_COMPANY_DETAILS,
      payload: { subsidiaries: response },
    });
    return;
  };
  const handleRowUpdate = async (newData, oldData, resolve, reject) => {
    console.log(newData);
    await updateCompanySubsidiary({
      company_id: companyId,
      country_code: "DEU",
      ...newData,
    });
    await refreshData();
    resolve();
  };
  const handleRowAdd = async (newData, resolve, reject) => {
    console.log(newData);
    if (!newData.city || !newData.street || !newData.zip_code) reject();
    else {
      await updateCompanySubsidiary({
        parent_id: companyId,
        country_code: "DEU",
        ...newData,
      });
      //   await refreshData();
      resolve();
    }
  };

  return (
    <MaterialTable
      title=""
      columns={subsidiariesColumns}
      data={subsidiaries || []}
      options={{
        actionsColumnIndex: -1,
      }}
      localization={{
        body: {
          emptyDataSourceMessage: "Keine Einträge",
          addTooltip: "Hinzufügen",
          deleteTooltip: "Löschen",
          editTooltip: "Bearbeiten",
          filterRow: {
            filterTooltip: "Filter",
          },
          editRow: {
            deleteText: "Diese Zeile wirklich löschen?",
            cancelTooltip: "Abbrechen",
            saveTooltip: "Speichern",
          },
        },
        grouping: {
          placeholder: "Spalten ziehen ...",
          groupedBy: "Gruppiert nach:",
        },
        header: {
          actions: "Aktionen",
        },
        pagination: {
          labelDisplayedRows: "{from}-{to} von {count}",
          labelRowsSelect: "Zeilen",
          labelRowsPerPage: "Zeilen pro Seite:",
          firstAriaLabel: "Erste Seite",
          firstTooltip: "Erste Seite",
          previousAriaLabel: "Vorherige Seite",
          previousTooltip: "Vorherige Seite",
          nextAriaLabel: "Nächste Seite",
          nextTooltip: "Nächste Seite",
          lastAriaLabel: "Letzte Seite",
          lastTooltip: "Letzte Seite",
        },
        toolbar: {
          addRemoveColumns: "Spalten hinzufügen oder löschen",
          nRowsSelected: "{0} Zeile(n) ausgewählt",
          showColumnsTitle: "Zeige Spalten",
          showColumnsAriaLabel: "Zeige Spalten",
          exportTitle: "Export",
          exportAriaLabel: "Export",
          exportName: "Export als CSV",
          searchTooltip: "Suche",
          searchPlaceholder: "Suche",
        },
      }}
      editable={{
        onRowUpdate: (newData, oldData) =>
          new Promise((resolve, reject) => {
            handleRowUpdate(newData, oldData, resolve, reject);
          }),
        onRowAdd: (newData) =>
          new Promise((resolve, reject) => {
            handleRowAdd(newData, resolve, reject);
          }),
      }}
    />
  );
};
